import { actions } from './constants'

const initialState = {
  fetching: false,
  selects: [],
  error: '',
  data: '',
  firstSelect: true,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.client.FETCH:
      return {
        ...state,
        fetching: true,
      }

    case actions.client.FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        selects: action.payload.selects,
      }

    case actions.client.FETCH_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}

export default reducer
